<template>
  <div class="left-panel">
    <!-- 监测点浏览 -->
    <div class="left-part1">
      <home-part :title="t('monitorTitle')" :ETitle="'Organization Tree'">
        <template #icon>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect x="2" y="3" width="14" height="12" rx="1.5" stroke="#2A62FF" stroke-width="0.8" fill="rgba(42,98,255,0.1)"/>
            <circle cx="9" cy="9" r="2" fill="#2A62FF" opacity="0.5"/>
            <path d="M5 6h8M5 12h6" stroke="#2A62FF" stroke-width="0.6" stroke-linecap="round" opacity="0.4"/>
          </svg>
        </template>
        <template v-slot:content>
          <SkeletonLoader v-if="loading" mode="tree" />
          <div v-else class="searchBlank">
            <!-- 搜索栏 -->
            <div class="searchPart">
              <el-input
                :placeholder="t('searchTip')"
                style="width: 264px"
                v-model="localFilter"
              />
              <span class="searchBtn" @click="$emit('search')">{{ t('searchBtn') }}</span>
            </div>
            <div class="bomLine"></div>

            <!-- 树 -->
            <div class="treeBlank">
              <el-tree
                class="filter-tree"
                :data="organizationTree"
                :props="defaultProps"
                :highlight-current="true"
                :check-on-click-node="true"
                default-expand-all
                :filter-node-method="filterNode"
                @node-click="node => $emit('node-click', node)"
                ref="orgtree"
              />
            </div>
          </div>
        </template>
      </home-part>
    </div>

    <!-- 企业分析 -->
    <div class="left-part2">
      <home-part :title="t('enterpriseAnalysis')" :ETitle="'Enterprise Analysis'">
        <template #icon>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect x="2" y="8" width="4" height="8" rx="0.8" fill="rgba(42,98,255,0.15)" stroke="#2A62FF" stroke-width="0.8"/>
            <rect x="7" y="4" width="4" height="12" rx="0.8" fill="rgba(42,98,255,0.15)" stroke="#2A62FF" stroke-width="0.8"/>
            <rect x="12" y="1" width="4" height="15" rx="0.8" fill="rgba(42,98,255,0.15)" stroke="#2A62FF" stroke-width="0.8"/>
            <circle cx="14" cy="3" r="1.2" fill="#77A8FF" opacity="0.6"/>
          </svg>
        </template>
        <template v-slot:content>
          <SkeletonLoader v-if="loading" mode="stat-card" />
          <div v-else class="enterprise-stat">
            <div class="enterprise-item">
              <div class="enterprise-icon enterprise-icon-total">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M14 2L17.09 8.26L24 9.27L19 14.14L20.18 21.02L14 17.77L7.82 21.02L9 14.14L4 9.27L10.91 8.26L14 2Z" stroke="#77A8FF" stroke-width="1.5" fill="none"/>
                </svg>
              </div>
              <div class="enterprise-info">
                <div class="enterprise-num" style="color: var(--color-dark-text-accent, #8AB4FF)">
                  <CountTo :startVal="0" :endVal="enterpriseTotal" :duration="4000" />
                </div>
                <div class="enterprise-label">{{ t('enterpriseTotal') }}</div>
              </div>
            </div>
            <div class="enterprise-divider"></div>
            <div class="enterprise-item">
              <div class="enterprise-icon enterprise-icon-new">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <rect x="2" y="6" width="24" height="18" rx="2" stroke="rgba(97,226,157,0.8)" stroke-width="1.5" fill="none"/>
                  <rect x="6" y="2" width="16" height="4" rx="1" stroke="rgba(97,226,157,0.8)" stroke-width="1.5" fill="none"/>
                  <line x1="14" y1="12" x2="14" y2="20" stroke="rgba(97,226,157,0.6)" stroke-width="1.5"/>
                  <line x1="10" y1="16" x2="18" y2="16" stroke="rgba(97,226,157,0.6)" stroke-width="1.5"/>
                </svg>
              </div>
              <div class="enterprise-info">
                <div class="enterprise-num" style="color: rgba(97,226,157,1)">
                  <CountTo :startVal="0" :endVal="lastMonthNew" :duration="4000" />
                </div>
                <div class="enterprise-label">{{ t('lastMonthNew') }}</div>
              </div>
            </div>
          </div>
        </template>
      </home-part>
    </div>
  </div>
</template>

<script>
import HomePart from "@/components/h5/homePart.vue";
import CountTo from 'vue-count-to'
import SkeletonLoader from "@/components/h5/SkeletonLoader.vue"
import { globalI18n } from '@/scripts/i18n'

export default {
  components:{ HomePart, CountTo, SkeletonLoader },
  data() {
    return {
      i18n: globalI18n,
      lang: globalI18n.getLang()
    }
  },
  props:{
    filterText:{
      type: String,
      default: ''
    },
    organizationTree:{
      type: Array,
      default: () => []
    },
    defaultProps:{
      type: Object,
      default:() => ({
        children: 'children',
        label: 'deptName'
      })
    },
    enterpriseTotal: {
      type: Number,
      default: 0
    },
    lastMonthNew: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  computed:{
    localFilter: {
      get(){ return this.filterText },
      set(val) { this.$emit('update:filterText', val) }
    },
    t() {
      void this.lang
      return this.i18n.t
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.deptName.indexOf(value) !== -1
    },
  },
  mounted() {
    this.$root.$on('lang-change', () => {
      this.lang = this.i18n.getLang()
      this.$forceUpdate()
    })
  },

  beforeDestroy() {
    this.$root.$off('lang-change')
  }
}
</script>

<style scoped lang="less">
.left-panel{
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.left-part1{
  width: 100%;
  flex: 1;
  min-height: 0;
  min-width: 0;
}

.left-part2{
  width: 100%;
  flex-shrink: 0;
  min-width: 0;

  // ponytail: override homePart's height:100% so enterprise content
  // determines the height naturally instead of being stretched
  ::v-deep .home-box{
    height: auto;
    min-height: 0;
  }
}

.searchBlank {
  flex: 3;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.searchPart{
  padding-top: 10px;
  display: flex;
}

.bomLine{
  width: 264px;
  height: 1px;
  border: 1px solid var(--color-dark-text-muted, #77A8FF);
}

.treeBlank{
  flex: 1;
  min-height: 0;
  min-width: 0;
  background: rgba(10, 22, 40, 0.65);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  overflow: auto;
  margin-top: 10px;
  border: 1px solid rgba(42, 98, 255, 0.08);
  border-radius: 8px;

  /* ponytail: shrink tree label font to match page scale */
  ::v-deep .el-tree-node__label {
    font-size: 12px;
  }
}

.cavBlank{
  flex: 2;
  height: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  position: relative;
}

.enterprise-stat{
  display: flex;
  align-items: center;
  gap: 12px;
}

.enterprise-item{
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(42, 54, 68, 0.4);
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 0;
}

.enterprise-icon{
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  svg {
    width: 20px;
    height: 20px;
  }
}

.enterprise-icon-total{
  background: rgba(119, 168, 255, 0.1);
  border: 1px solid rgba(119, 168, 255, 0.25);
}

.enterprise-icon-new{
  background: rgba(97, 226, 157, 0.1);
  border: 1px solid rgba(97, 226, 157, 0.3);
}

.enterprise-info{
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.enterprise-num{
  font-family: "FROSTBITE-Narrow", sans-serif;
  line-height: 1.2;
  font-size: 18px;
}

.enterprise-label{
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  font-size: 12px;
  color: #FFFFFF;
}

.enterprise-divider{
  width: 1px;
  height: 60%;
  flex-shrink: 0;
  background: linear-gradient(180deg, transparent, rgba(42,98,255,0.3), transparent);
}

.detItem{
  flex: 1;
  min-width: 0;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

.detItemImg{
  width: 12px;
  height: 12px;
}

.numFont{
  font-family: "FROSTBITE-Narrow", sans-serif;
  line-height: 28px;
  font-size: 18px;
}

.textFont{
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  font-size: 12px;
  color: #FFFFFF;
}

.centerNum{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.bignum{
  font-family: "FROSTBITE-Narrow", sans-serif;
  line-height: 28px;
  font-size: 20px;
  color: #FFFFFF;
}

.searchBtn{
  font-family: "AlibabaPuHuiTi-2-55-Regular","sans-serif";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 61px;
  height: 26px;
  font-size: 13px;
  color: var(--color-dark-text-accent, #8AB4FF);
  background: rgba(42,98,255,0.1);
  border: 1px solid rgba(42,98,255,0.3);
  border-radius: 6px;
  margin-left: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4,0,0.2,1);

  &:hover {
    background: rgba(42,98,255,0.2);
    border-color: rgba(42,98,255,0.5);
    box-shadow: 0 0 12px rgba(42,98,255,0.15);
    color: #FFFFFF;
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
